import { useLocation, useNavigate } from "react-router-dom";

import { useSidebar } from "@/components/ui/sidebar";
import { PATHS } from "@/constants/paths";

import { useCallAssistantTour } from "./use-call-assistant-tour";
import { useMainTour } from "./use-main-tour";

interface IUseStartTour {
  isOnCallAssistantTerritory: boolean;
  startTour: () => void;
}

// NOTE: NSAI-4345 — the tour entry point moved out of the top strip into the
// account menu, so the "which tour, from which route" logic lives here rather
// than in whichever component happens to host the button.
export const useStartTour = (): IUseStartTour => {
  const { startTour: startMainTour } = useMainTour();
  const { startTour: startCallAssistantTour } = useCallAssistantTour();
  const { setIsOpen: setSidebarOpen } = useSidebar();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const isOnCallAssistantTerritory =
    pathname === PATHS.CALL_ASSISTANT ||
    pathname.startsWith(`${PATHS.CALL_ASSISTANT}/`) ||
    pathname === PATHS.UPLOADS;

  const startTour = (): void => {
    if (isOnCallAssistantTerritory) {
      // NOTE: Pull the user back to /call-assistant before starting so the
      // mini-tour always runs from step 0. Avoids the "partial tour" feeling
      // when the user hits the entry point from /uploads.
      if (pathname !== PATHS.CALL_ASSISTANT) {
        navigate(PATHS.CALL_ASSISTANT);
      }
      startCallAssistantTour();
      return;
    }

    // NOTE: Land on a fresh /chat (no chatId) so an archived chat doesn't
    // swap #chat-input for the ArchivedChatBanner mid-tour.
    if (pathname !== PATHS.CHAT) {
      navigate(PATHS.CHAT);
    }
    setSidebarOpen(true);
    startMainTour();
  };

  return { isOnCallAssistantTerritory, startTour };
};
